<template>
  <div :class='["cb",{"twoBox":dcbjzt,"box":!dcbjzt}]' v-if="tbdw">
    <p style="padding-top: 60px; text-align: center"  v-if="csjg">
      <span class="red">
        {{csjg}}
      </span>
    </p>
    <div class="redBox" v-if='dcbjzt'>
      <div>
          <p>报价剩余时间</p>
          <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
        <p class='bjNumTbr' v-if='ifProcure'>当前第<span class='bjNum'>{{dcbjcs}}</span>轮报价</p>
      </div>
    </div>
    <table class="list">
      <thead>
        <tr>
          <td v-for="(val, key, index) in tableHead" :key="index">{{ key }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(val, key, index) in tbdwData" :key="index">{{ val }}</td>
        </tr>
      </tbody>
    </table>
    <div class="btnBox">
      <el-button type="primary" @click="bj" style="min-width: 130px" v-if='dcbjzt'
        >报价</el-button
      >
      <el-button type="primary" @click="lookTbdw" style="min-width: 130px" v-if='!ifProcure' :disabled='!ckcbjg'
        >查看所有唱标结果</el-button
      >
    </div>
    <!-- 报价 -->
    <el-dialog
      title="报价"
      :visible.sync="dialogVisible"
      width="450px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <p class='bjNumP'>当前第<span class='bjNum'>{{dcbjcs}}</span>轮报价</p>
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item style="margin-bottom: 0;" label="本轮报价" prop='bj' :rules='[{required:true,trigger:"blur",message:"必填项"}]'>
            <el-input v-model="form.bj" :input="proving()" style="width:180px" type="number"></el-input> {{ this.bjdw }}
          </el-form-item>
        </el-form>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveBjTime" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 弹窗 -->
    <el-dialog
      title="查看所有唱标结果"
      :visible.sync="dialogTableVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-input
        style="margin-bottom: 10px; width: 300px; float: right"
        placeholder="投标单位名称"
        v-model="tbdwmc"
        class="input-with-select"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchTbdw"
        ></el-button>
      </el-input>
      <template v-if="isPublish != 1">
        <el-table ref="table" :data="tableData" border style="width: 100%">
          <el-table-column type="index" label="序号" width="60">
            <template slot-scope="scope">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</template>
          </el-table-column>
          <el-table-column
            prop="fcqymc"
            label="投标单位名称"
            show-overflow-tooltip
            min-width="180"
          ></el-table-column>
          <el-table-column
            :prop="val"
            :label="key"
            width="140"
            v-for="(val, key, index) in tableHead"
            :key="index"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <el-table
          ref="table"
          border
          :data="tableData"
          style="width: 100%"
          max-height="570"
        >
          <el-table-column type="index" label="序号" width="60">
            <template slot-scope="scope">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</template>
          </el-table-column>
          <el-table-column
            prop="qymc"
            label="投标单位名称"
            show-overflow-tooltip
            min-width="180"
          ></el-table-column>
          <el-table-column
            width="140"
            show-overflow-tooltip
            v-for="(item, index) in priceAry"
            :key="index"
            :label="item.bjcsmc"
          >
            <template slot-scope="scope">
              {{ scope.row.cgkbdcbjList[index].bjje }}
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="clear">
        <span class="lf pageNum">共{{ total }}家。</span>
        <myPage
          class="rt"
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="dialogTableVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import myPage from "../components/page";
import myClock from '../components/clock/clock'
export default {
  name: "tbcb",
  props: ["djlcId"],
  components: {
    myPage,myClock
  },
  data() {
    return {
      tbdw: "",
      zgxj: "",
      kz: "",
      xfbfb: "",
      dialogTableVisible: false,
      tableHead: {},
      tbdwData: {},
      tableData: [],
      tbdwmc: "",
      pageSize: 10,
      currentPage: 1,
      total: 0,
      csjg: "",
      lcSteps: JSON.parse(
        localStorage.getItem("lcSteps") ? localStorage.getItem("lcSteps") : ""
      ),
      aaa: false,
      isPublish: "",
      priceAry: "",
      sycbjgbs:true,
      ifProcure:true,
      dcbjzt:false,//是否显示报价按钮
      ckcbjg:true,//是否可点击查看报价按钮
      dialogVisible:false,
      shenyu:null,
      intervalTbqr:null,
      waitLoading:false,
      form:{
        bj:''
      },
      dcbjcs:0,
      bjdw: '', // 报价单位：杨金智新增
      point: 2, // 报价保留小数点位数：张炎新增
    };
  },
  created() {
    this.aaa = this.lcSteps.some((item) => {
      return item.ycmc.includes("多次报价");
    });
  },
  methods: {
    getData() {
      let para = {
        djlcId: this.djlcId,
      };
      clearInterval(this.intervalTbqr);
      this.intervalTbqr=null;
      this.dcbjzt=false;
      this.shenyu=0;
      this.$api
        .zdcbTbr(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tbdw = res.data.data.tbdw;
            this.kz = res.data.data.kbxm.kz;
            this.xfbfb = res.data.data.kbxm.xfbfb;
            this.zgxj = res.data.data.kbxm.fmzgxj;
            this.csjg = res.data.data.csList;
            this.tableHead = res.data.data.bjxsmc;
            this.dcbjzt=res.data.data.dcbjzt;
            this.ckcbjg=res.data.data.ckcbjg;
            // this.sycbjgbs=res.data.data.sycbjgbs;
            this.dcbjcs=res.data.data.kbxm.dcbjcs
            this.ifProcure=res.data.data.ifProcure;
            this.bjdw = res.data.data.bjdw; // 报价单位：杨金智新增
            this.point = res.data.data.point; // 报价保留小数点位数：张炎新增

            if (this.aaa) {
              this.tbdwData[this.tableHead["总报价（元）"]] =
                res.data.data.tbdw.tbbj;
            } else {
              for (let key in this.tableHead) {
                if (res.data.data.tbdwMap) {
                  this.tbdwData[this.tableHead[key]] =
                    res.data.data.tbdwMap[this.tbdw.id][this.tableHead[key]];
                } else {
                  this.tbdwData[this.tableHead[key]] =
                    res.data.data.tbdw[this.tableHead[key]];
                }
              }
            }
            if(this.dcbjzt){
              var dcbjjssj=res.data.data.dcbjjssj;
              var nowTime=new Date().getTime();
              this.shenyu=dcbjjssj-nowTime;
              if(this.shenyu>=1000){
                  this.tbqrshenyuFun();
                }else{
                  
                }
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    async lookTbdw() {
      this.dialogTableVisible = true;
      this.currentPage = 1;
      this.tbdwmc = "";
      await this.getAllData();
      if (this.isPublish == 1) {
        console.log("公布了");
      } else {
        this.getTableList();
      }
    },
    async getAllData() {
      let para = {
        djlcId: this.djlcId,
        endCode: 0,
      };
      try {
        let res = await this.$api.dcbjquery(para);
        if (res.status == 200) {
          this.isPublish = res.data.data.isPublish;
          res.data.data.dcbj.forEach((ele, index) => {
            this.priceAry = [...ele.cgkbdcbjList];
          });
          this.total = res.data.data.total;
          this.tableData = res.data.data.dcbj;
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
      } catch (err) {
        console.log("招标人", err);
      }
    },
    getTableList() {
      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.$api
        .getCbData(para)
        .then((res) => {
          if (res.data.meta.success) {
            var objs = res.data.data.tbdwMap;
            this.total = res.data.data.data.total;
            if (this.aaa) {
              this.tableHead = {
                "总报价（元）": "tbbj",
              };
            } else {
              this.tableHead = res.data.data.bjxsmc;
            }
            if (objs) {
              var arr = res.data.data.data.tbdwList;
              arr.forEach((item, index) => {
                for (let key in objs[item.id]) {
                  item[key] = objs[item.id][key];
                }
              });
              this.tableData = arr;
            } else {
              this.tableData = res.data.data.data.tbdwList;
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    searchTbdw() {
      this.currentPage = 1;
      this.getTableList();
    },
    changePage(val) {
      this.currentPage = val;
      this.getTableList();
    },
    bj(){
      this.dialogVisible=true;
    },
    saveBjTime(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.waitLoading=true;
            let para={
              ...this.form
            }
            this.$api.tbdwxgdcbj(para).then((res) => {
                if (res.data.meta.success) {
                  this.dialogVisible=false;
                  this.form.bj='';
                  let obj={
                    lx:'tb',
                    data:{
                      index:3,
                      msg:'',
                      all:true
                    }
                  }
                  this.$emit('send',JSON.stringify(obj))
                  this.getData();
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.meta.message,
                  });
                }
                this.waitLoading=false;
              })
              .catch(() => {this.waitLoading=false;});
          } else {
            return false;
          }
        });
      
    },
    //计算剩余时间倒计时
    tbqrshenyuFun(){
      var _this=this;
      var time=this.shenyu
      var flag=false
      clearInterval(this.intervalTbqr);
      this.intervalTbqr=null;
      this.intervalTbqr=setInterval(function(){
        time=time-2000
        if(time<1000){
          if(!flag){
            flag=true
            if(!_this.isOver){
              let obj={
                lx:'tb',
                data:{
                  index:3,
                  msg:'',
                  all:true
                }
              }
              _this.$emit('send',JSON.stringify(obj))
            }else{
              _this.getData();
            }
          }
          clearInterval(_this.intervalTbqr);
          _this.intervalTbqr=null;
          return;
        }
      },2000)
    }, 
//     proving() {
// 　　　　　　　　　 // this.addval 是input的值　　
//       // 先把非数字的都替换掉，除了数字和.
//       this.form.bj = this.form.bj.replace(/[^\d.]/g, '');
//       // 必须保证第一个为数字而不是.
//       this.form.bj = this.form.bj.replace(/^\./g, '');
//       //除了0.不能是0开头
//       this.form.bj = this.form.bj.replace(/^0\d$/g, Number(this.addval));
//       // 保证只有出现一个.而没有多个.
//       this.form.bj = this.form.bj.replace(/\.{2,}/g, '');
//       // 保证.只出现一次，而不能出现两次以上
//       this.form.bj = this.form.bj.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
//       let index = -1
//       for (let i in this.form.bj) {
//         if (this.form.bj[i] === '.') {
//           index = i
//         }
//         if (index !== -1) {
//           if (i - index > 2) {
//             this.form.bj = this.form.bj.substring(0, this.form.bj.length - 1)
//           }
//         }
//       }
//     },
    proving() {
      this.form.bj = this.cutOutNum(this.form.bj, this.point);
    },

    /**
     * 截断小数点后几位
     * @param {Number} num 需要处理的数字
     * @param {Number} point 需要保留的小数点位数
     */
    cutOutNum(num, point) {
      let numStr = num.toString();
      let index = numStr.indexOf('.');
      if (index === -1) {
        return numStr;
      } else {
        return numStr.substring(0, index + point + 1);
      }
    }
  },
  mounted() {
    this.getData();
  },
};
</script>    
<style lang="scss" scoped>
::v-deep .el-table__body-wrapper{
  height: 300px;
  overflow-y: scroll;
}
 .bjNumP{
    color:#333;
    font-weight: bold;
    font-size: 18px;
    margin-bottom:10px;
  }
  .bjNum{
    color:#0060B2;
  }
  .dialogBox .el-form{
    background: #f5f5f5;
    padding:10px 0;
  }
  .redBox{
    position: relative;
  }
  .bjNumTbr{
    position: absolute;
    top:0;
    right:100px;
  }

</style>